import { render, staticRenderFns } from "./LbTableActionRow.vue?vue&type=template&id=3fb5b428"
import script from "./LbTableActionRow.vue?vue&type=script&lang=js"
export * from "./LbTableActionRow.vue?vue&type=script&lang=js"
import style0 from "./LbTableActionRow.vue?vue&type=style&index=0&id=3fb5b428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports